import { useEffect, useState } from 'react';

export default function useDebounce(value: any, delay: number) {
  const [debounced_value, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debounced_value;
}
